import { Component, Input } from '@angular/core';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';
import { ValidationHeaderComponent } from '../validation-header/validation-header.component';
import { ValidateSpecialistEncounterFormComponent } from '../validate-specialist-encounter-form/validate-specialist-encounter-form.component';

@Component({
    selector: 'app-validate-specialist-encounter',
    templateUrl: './validate-specialist-encounter.component.html',
    styleUrls: ['./validate-specialist-encounter.component.scss'],
    imports: [ValidationHeaderComponent, ValidateSpecialistEncounterFormComponent]
})
export class ValidateSpecialistEncounterComponent {
  collapsed = false;

  @Input() patientAttachment: PatientAttachment;

  constructor() {}


  onCollapseChange(collapsed) {
    this.collapsed = collapsed;
  }

  collapse() {
    this.collapsed = true;
  }

  expand() {
    this.collapsed = false;
  }
}
